module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-4-photo-2-5e9f0c750ba298f9a055323b2da6c0eb.webp";